<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-tabs>
      <v-tab>Informações</v-tab>
      <v-tab v-if="entry.id">Produtos em Depósito</v-tab>
      <v-tab>Depósito Inicial</v-tab>

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="entry.name"
              v-bind="getObject('name')"
              label="Nome"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12" sm="8">
            <v-text-field
              v-model="entry.location"
              v-bind="getObject('location')"
              label="Localização"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <MaskedTextField
              v-bind="getObject('capacity')"
              :inputData.sync="entry.capacity"
              mask-type="currency"
              label="Capacidade"
              suffix="Kg"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- produtos em depósito -->
      <v-tab-item v-if="entry.id">
        <v-row>

          <v-col cols="12" class="mt-3">
            <ProducedProductIndex
              :producedProducts="entry.producedProducts"
              :initialStorehouse="true"
              :readOnly="true"
              objectType="StorehouseProduct"
              key="storehoused_products"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- depósito inicial -->
      <v-tab-item>
        <v-row>
          <v-col cols="12" class="mt-3">
            <ProducedProductIndex
              v-if="entry.canBeDeleted"
              :producedProducts="entry.producedProductsAttributes"
              :initialStorehouse="true"
              :readOnly="readOnly"
              objectType="InitialStorehouseProduct"
            />
            <ProducedProductIndex
              v-else
              :producedProducts="entry.producedProductsAttributes"
              :readOnly="true"
              :initialStorehouse="true"
              objectType="InitialStorehouseProduct"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import ProducedProductIndex from "@models/produced_products/index.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    ProducedProductIndex: ProducedProductIndex,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
